// API
import { tmxApiCall } from './index'

// Utilities
import Logger from '../utility/loggerUtil.js'

export default {
  /**
   * Gets the name of the bank that matches the given routing number.
   * @param {String} routingNum - A bank routing number.
   * @returns {Promise<{bankInfo: String}>} Returns the bank name.
   */
  async getBankName (routingNum) {
    return tmxApiCall('get', '/bankInfo', {
      params: {
        routingNum
      }
    }).catch(e => {
      Logger.error('Failed to get bank name in getBankName()')
      Logger.debug(e)
      throw e
    })
  }
}
